import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		root: {},
		header: {
			fontSize: 38,
			fontWeight: 700,
			marginBottom: 40
		},
		requestDateBox: {},
		requestDateTitle: {
			fontSize: 16,
			fontWeight: 500,
			marginBottom: 20
		},
		requestDateInputsBox: {
			display: 'flex',
			[theme.breakpoints.down('sm')]: {
				flexDirection: 'column'
			}
		},
		requestDateInputIcon: {
			'& .MuiIconButton-root': {
				padding: '0 !important'
			}
		},
		requestDateInputMargin: {
			marginRight: 10
		},
		requestDateInput: {
			[theme.breakpoints.down('sm')]: {
				marginBottom: 0
			}
		},
		requestPlaceBox: {},
		requestPlaceTitle: {
			marginTop: 35,
			fontSize: 16,
			fontWeight: 500,
			marginBottom: 30
		},
		requestPlaceInput: {
			marginBottom: 20
		},
		requestPlaceCityBox: {
			display: 'flex'
		},
		requestPlaceInputMargin: {
			marginRight: 10
		}
	};
});
